"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _basic = _interopRequireDefault(require("./_basic"));
class GraphApi extends _basic.default {
  /**
   * Represents a Tables Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      graphDBUrl,
      accountIdFactory,
      timeout
    } = _ref;
    super({
      userTokenFactory,
      accountIdFactory
    });
    this.graphDBUrl = graphDBUrl;
    this.axios = _axios.default.create({
      ...(timeout && {
        timeout
      }),
      baseURL: `${graphDBUrl}/${this.accountIdFactory}`,
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  async _callApi(_ref2) {
    let {
      url,
      data,
      method
    } = _ref2;
    const {
      data: res
    } = await this.axios({
      url: `${this.graphDBUrl}/${this.accountIdFactory}/${url}`,
      method,
      data,
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).catch(e => {
      const response = _lodash.default.get(e, 'response.data', e);
      const err = new Error(response.error);
      err.data = response;
      throw err;
    });
    return res;
  }

  /**
   * @param {String} param0.query cypher query for graph db
   * @param {Object} param0.params Object with params to query
   * @param {String} param0.database Database name
   */
  async executeQuery(_ref3) {
    let {
      query,
      params,
      database
    } = _ref3;
    return this._callApi({
      data: {
        query,
        params,
        database
      },
      method: 'post',
      url: 'query'
    });
  }

  // eslint-disable-next-line class-methods-use-this
  stringify(obj) {
    if (_lodash.default.isObject(obj)) return `{${Object.entries(obj).map(_ref4 => {
      let [key, value] = _ref4;
      return `${key}:${JSON.stringify(value)}`;
    }).join(', ')}}`;
    return obj || '';
  }
  /**
   * @description create node with label
   * @param {String} param0.label label of node
   * @param {String} param0.database Database name
   * @param {Object} param0.data data to create
   */
  async createNode(_ref5) {
    let {
      label,
      data,
      database
    } = _ref5;
    return this.executeQuery({
      query: `create (n:${label} $data) return n`,
      params: {
        data
      },
      database
    });
  }

  /**
   * @description delete nodes which match label
   * @param {String} param0.database Database name
   * @param {String} param0.label label of node
   * @param {Object} param0.where object to query e.g {id:1}
   */
  async matchNode(_ref6) {
    let {
      label,
      where,
      database
    } = _ref6;
    return this.executeQuery({
      query: `match (n:${label} ${this.stringify(where)}) return n`,
      database
    });
  }

  /**
   * @description delete nodes which match label
   * @param {String} param0.database Database name
   * @param {String} param0.label label of node
   * @param {Object} param0.where object to query e.g {id:1}
   */
  async deleteNode(_ref7) {
    let {
      label,
      where,
      database
    } = _ref7;
    return this.executeQuery({
      query: `match (n:${label} ${this.stringify(where)}) delete n`,
      database
    });
  }

  /**
   * @description update nodes by label
   * @param {String} param0.label label of node
   * @param {Object} param0.where object to query e.g {id:1}
   * @param {String} param0.database Database name
   * @param {Object} param0.data data to update
   */
  async setNode(_ref8) {
    let {
      label,
      data,
      where,
      database
    } = _ref8;
    return this.executeQuery({
      query: `match (n:${label} ${this.stringify(where)}) set n+=$data return n`,
      params: {
        data
      },
      database
    });
  }
  /**
   *
   * @returns {Array} database names
   */
  async listDatabases() {
    const {
      databases
    } = await this._callApi({
      method: 'get',
      url: 'databases'
    });
    return databases;
  }

  /**
   *
   * @param {String} param0.database database name
   */
  async createDatabase(_ref9) {
    let {
      database
    } = _ref9;
    return this._callApi({
      data: {
        database
      },
      method: 'put',
      url: 'databases'
    });
  }

  /**
   *
   * @param {String} param0.database database name
   */
  async getDatabaseInfo(_ref10) {
    let {
      database
    } = _ref10;
    return this._callApi({
      method: 'get',
      url: `databases/${encodeURIComponent(database)}`
    });
  }

  /**
   *
   * @param {String} param0.database database name
   */
  async dropDatabase(_ref11) {
    let {
      database
    } = _ref11;
    return this._callApi({
      data: {
        database
      },
      method: 'delete',
      url: 'databases'
    });
  }
}
var _default = GraphApi;
exports.default = _default;